<div *ngIf="service?.fullWidthImages?.length" class="container">
  <br />
  <br />
  <br />
  <br />
  <br />
  <app-hero-carousel [data]="service" />
</div>
<div
  class="mx-5 mt-5"
  [ngStyle]="{ 'text-align': 'end' }"
  *ngIf="service.pdfPath"
>
  <a [href]="service.pdfPath" download class="btn btn-primary fw-bold">
    {{ "Download PDF" | translate }}
  </a>
</div>
<app-articale-service
  *ngIf="service?.category === 'article'"
  [data]="service"
  [language]="language"
></app-articale-service>
<app-image-service
  *ngIf="service?.category === 'oneImage'"
  [data]="service"
  [language]="language"
></app-image-service>
<app-multi-images-service
  *ngIf="service?.category === 'multiImages'"
  [data]="service"
  [language]="language"
></app-multi-images-service>
<app-video-service
  *ngIf="service?.category === 'video'"
  [data]="service"
  [language]="language"
></app-video-service>
<app-course-details
  *ngIf="service?.category === 'Coursedetails'"
  [data]="service"
  [language]="language"
>
</app-course-details>

<app-multi-text-with-image
  *ngIf="service?.multiTextWithImage"
  [data]="service.multiTextWithImage"
></app-multi-text-with-image>

<app-accordion [data]="service" *ngIf="service?.accordion" />
